import API from './api';

export const getOperationsIntelligence = (params = {}) => {
  const browserTimeZone = typeof Intl !== 'undefined'
    ? Intl.DateTimeFormat().resolvedOptions().timeZone
    : '';
  return API.get('/intelligence/operations', {
    params: {
      ...params,
      ...(params.timeZone || !browserTimeZone ? {} : { timeZone: browserTimeZone }),
    },
  });
};
